import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=02330d3a&"
import script from "./Coins.vue?vue&type=script&lang=js&"
export * from "./Coins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports